import React from "react";
import MuscleDiagramCard from "../../../../dashboard/calendar/components/MuscleDiagramCard";
import { displayDateRange } from "../../../../../utils/questionnaire";

const WorkloadStats = ({ start, end }) => {
  return (
    <article id="summary-muscle-diagram">
      <header>
        <h4>Workload by Muscle Group</h4>
        <p className="p4">{displayDateRange(start, end)}</p>
      </header>
      <div className="workload-content">
        <MuscleDiagramCard isComposition={true} />
      </div>
    </article>
  );
};

export default WorkloadStats;
